// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2Yl5M","footerDesktop":"Footer_footerDesktop__tG4uF"};